import Immutable from 'immutable';
import memoize from 'memoize-one';
import { arrayOf, bool, func, number, oneOfType, string } from 'prop-types';
import { Component } from 'react';
import { list, map } from 'react-immutable-proptypes';

import {
  OrganizationNetworkId,
  OrganizationType,
} from '@alkem/lib-front-model';

import { OrganizationLegacyAddableAutocomplete } from 'components/ui/autocomplete/organization';

import AuthFormSelectWrapper from './select-wrapper';

class AuthFormOrganization extends Component<{
  formKey: string;
  onChange: Function;
  targetMarkets?: number[] | null;
  value?: Immutable.Map<string, any>;
  error?: boolean | Immutable.List<any>;
  errorMessage?: string;
  disabled?: boolean;
}> {
  static propTypes = {
    formKey: string.isRequired,
    targetMarkets: arrayOf(number),
    value: map,
    error: oneOfType([bool, list]),
    errorMessage: string,
    disabled: bool,
    onChange: func.isRequired,
  };

  onSelect = ({ label, id }) => {
    const { formKey, onChange, disabled } = this.props;
    if (disabled) {
      return;
    }
    onChange({ formKey, value: Immutable.Map({ label, id }) });
  };

  onAdd = (label, data) => {
    const { formKey, onChange, disabled } = this.props;
    if (disabled) {
      return;
    }
    if (data.id === -1) {
      label = data.label;
    }
    onChange({ formKey, value: Immutable.Map({ label }) });
  };

  shouldAdd = (org) => org.id === -1;

  onUnselect = () => {
    const { formKey, onChange, disabled } = this.props;
    if (disabled) {
      return;
    }
    onChange({ formKey });
  };

  getValue = memoize((value) =>
    Immutable.Map.isMap(value) ? [value.toJS()] : [],
  );

  render() {
    const { formKey, value, targetMarkets, error, errorMessage, disabled } =
      this.props;
    const filters = {
      organization_type_in: [
        OrganizationType.MANUFACTURER,
        OrganizationType.RETAILER,
        OrganizationType.PRIVATE_LABEL,
      ],
      exclude_parents: true,
      network_id: OrganizationNetworkId.PRODUCTION,
      target_market_ids: targetMarkets,
      with_prospects: true,
    };
    return (
      <AuthFormSelectWrapper error={error} errorMessage={errorMessage}>
        <OrganizationLegacyAddableAutocomplete
          id={`auth-form-organization-${formKey}`}
          value={this.getValue(value)}
          onSelect={this.onSelect}
          onAdd={this.onAdd}
          shouldAdd={this.shouldAdd}
          onUnselect={this.onUnselect}
          disabled={disabled}
          filters={filters}
        />
      </AuthFormSelectWrapper>
    );
  }
}

export default AuthFormOrganization;
